"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _styles = require("@material-ui/core/styles");
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _ProfileActions = require("../ProfileActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var StripeComponent;
var Elements;
try {
  StripeComponent = require('react-platform-purchase/dist/Purchase/Stripe').default;
  Elements = require('react-stripe-elements').Elements;
} catch (error) {}
var useStyles = (0, _styles.makeStyles)({
  root: {
    minWidth: 275
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  marged: {
    margin: "10px 10px"
  }
});
function UpdateStripePaymentMethod() {
  var _stripeOptions$defaul, _stripeOptions$defaul2, _stripeOptions$defaul3, _stripeOptions$defaul4, _stripeOptions$defaul5;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var stripeFormRef = /*#__PURE__*/_react.default.createRef();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inProgress = _useState4[0],
    setInProgress = _useState4[1];
  var stripeOptions = (0, _reactRedux.useSelector)(function (state) {
    var _state$auth, _state$auth$user;
    return state === null || state === void 0 ? void 0 : (_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : (_state$auth$user = _state$auth.user) === null || _state$auth$user === void 0 ? void 0 : _state$auth$user.stripe_extension;
  });
  var handleClickOpen = function handleClickOpen() {
    setOpen(true);
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var onPayment = function onPayment(token) {
    setInProgress(true);
    dispatch({
      type: _ProfileActions.UPDATE_STRIPE_PAYMENT_METHOD,
      model: {
        payment_method_token: token.id
      },
      onSuccess: function onSuccess() {
        return handleClose();
      },
      onFailure: function onFailure() {
        return setInProgress(false);
      }
    });
  };
  if (!StripeComponent || !Elements) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (stripeOptions === null || stripeOptions === void 0 ? void 0 : stripeOptions.default_payment_method) !== null && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: "m-4 md:m-8 p-4"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12
  }, (stripeOptions === null || stripeOptions === void 0 ? void 0 : stripeOptions.default_payment_method.type) === 'card' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    component: "h2"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Your current payment card:",
    defaultMessage: "Your current payment card:"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.marged
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.pos
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Brand: ",
    defaultMessage: "Brand: "
  }), " ", stripeOptions === null || stripeOptions === void 0 ? void 0 : (_stripeOptions$defaul = stripeOptions.default_payment_method) === null || _stripeOptions$defaul === void 0 ? void 0 : _stripeOptions$defaul.brand), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.pos
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Expiration month: ",
    defaultMessage: "Expiration month: "
  }), " ", stripeOptions === null || stripeOptions === void 0 ? void 0 : (_stripeOptions$defaul2 = stripeOptions.default_payment_method) === null || _stripeOptions$defaul2 === void 0 ? void 0 : _stripeOptions$defaul2.expiration_month), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.pos
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Expiration year: ",
    defaultMessage: "Expiration year: "
  }), " ", stripeOptions === null || stripeOptions === void 0 ? void 0 : (_stripeOptions$defaul3 = stripeOptions.default_payment_method) === null || _stripeOptions$defaul3 === void 0 ? void 0 : _stripeOptions$defaul3.expiration_year), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.pos
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Number: ",
    defaultMessage: "Number: "
  }), " ", stripeOptions === null || stripeOptions === void 0 ? void 0 : (_stripeOptions$defaul4 = stripeOptions.default_payment_method) === null || _stripeOptions$defaul4 === void 0 ? void 0 : _stripeOptions$defaul4.number))), (stripeOptions === null || stripeOptions === void 0 ? void 0 : stripeOptions.default_payment_method.type) === 'sepa_debit' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    component: "h2"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Your current bank account:",
    defaultMessage: "Your current bank account:"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.marged
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.pos
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "IBAN: ",
    defaultMessage: "IBAN: "
  }), " ", stripeOptions === null || stripeOptions === void 0 ? void 0 : (_stripeOptions$defaul5 = stripeOptions.default_payment_method) === null || _stripeOptions$defaul5 === void 0 ? void 0 : _stripeOptions$defaul5.iban)))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    justify: "flex-end",
    alignItems: "center",
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: handleClickOpen,
    className: classes.marged
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Update",
    defaultMessage: "Update"
  })))))), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "form-dialog-title"
  }, /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_DialogContentText.default, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Update your payment method",
    defaultMessage: "Update your payment method"
  })), /*#__PURE__*/_react.default.createElement(Elements, null, /*#__PURE__*/_react.default.createElement(StripeComponent, {
    handlePayment: onPayment,
    formRef: stripeFormRef
  }))), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleClose,
    color: "primary",
    disabled: inProgress
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Cancel",
    defaultMessage: "Cancel"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: function onClick() {
      var _stripeFormRef$curren;
      return (_stripeFormRef$curren = stripeFormRef.current) === null || _stripeFormRef$curren === void 0 ? void 0 : _stripeFormRef$curren.handleSubmit();
    },
    color: "primary",
    disabled: inProgress
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Submit",
    defaultMessage: "Submit"
  }))))));
}
var _default = UpdateStripePaymentMethod;
exports.default = _default;